<section class="w-100 d-flex flex-column justify-content-center old-style">
  <div class="pb-4">
    <a href="https://{{appVariables.WHITELABEL_LINK}}">
      <img
        class="d-block mx-auto logo"
        src="assets/img/{{appVariables.WHITELABEL_LOGO}}"
        alt="{{appVariables.WHITELABEL_BRAND}}"
      />
    </a>
  </div>
  <div class="d-flex flex-row justify-content-center">
    <h1 class="text-white">This invite was canceled or expired.</h1>
  </div>
</section>
